import script from "./DefaultCarrierForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultCarrierForm.vue?vue&type=script&setup=true&lang=js"

import "./DefaultCarrierForm.vue?vue&type=style&index=0&id=13083a7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13083a7e"]])

export default __exports__